import React from 'react';
import { Modal } from 'antd';
import LoadableButton from '../buttons/LoadableButton.jsx';

export default function ConfirmationModal({ children,isOpen = false, setIsOpen, width, type, message, onConfirm, isLoading, loadingLabel = 'Loading...' }) {

    return (
        <Modal
            open={isOpen}
            closeIcon={false}
            footer={false}
            maskClosable={false}
            keyboard={false}
            width={width}
        >
            <div className='lg:pb-1'>
                <div className='p-6'>
                    {children}
                    <div className="flex justify-center mt-4">
                        {type == 'success' ? (<img src="/assets/icons/green-success-icon.svg" alt="icon" width={100} />) : (<img src="/assets/icons/red-cross-icon.svg" alt="icon" width={100} />)}
                    </div>
                    <p className="text-xl text-[#2F2B3D] font-semibold text-center my-8">{message}</p>
                    <div className='flex justify-center items-center gap-5 mt-5'>
                        <button onClick={() => setIsOpen(false)} disabled={isLoading} className='bg-[#D91819] text-sm text-white font-medium uppercase px-10 py-2 rounded-lg hover:bg-[#aa0001] duration-500'>No</button>
                        <LoadableButton
                            className='bg-[#2D9B63] text-sm text-white font-medium uppercase px-10 py-2 rounded-lg hover:bg-[#096034] duration-500'
                            onClick={() => onConfirm()}
                            disabled={isLoading}
                            lable='Yes'
                            isLoading={isLoading}
                            loadingLable={loadingLabel}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    )
}
